export default __webpack_public_path__ + "static/media/addToCart-help.206db62f.png";